import { createSlice } from '@reduxjs/toolkit';

export const webSettingsSlice = createSlice({
	name: 'webSettings',
	initialState: {
		data: null,
	},
	reducers: {
		updateWebSettings: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { updateWebSettings } = webSettingsSlice.actions;
export default webSettingsSlice.reducer;
